/**
 * Created by karora on 2018-06-25
 *
 * Details of specific firmware
 */

export class FirmwareDetails {
  uid: number;
  name: string;
  uri: string;
  hash: string;
  hashtype: string;
  hwmaj: number;
  hwmin: number;
  hwpatch: number;
  major: number;
  minor: number;
  patch: number;
  size: number;
  stable: boolean;
  comment: string;
  created: string;
  author: string;
  breakingchange: boolean;
  fwsetid: number;
}
